export const PRIMARY_MESSAGE = 'Thank You';
export const SECONDARY_MESSAGE =
  'Thanks for getting in touch. A member of our team will get back to you as soon as possible.';
